import {FormControl} from 'platform/components';

import {UseFormReturn, useWatch} from 'react-hook-form';
import {useLocation} from 'react-router-dom';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {
  DepositSection,
  DocumentTemplateOptionGroup,
  SettingsFooter,
  useSeriesOptions,
} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {FormType} from '../../types/ServiceOrderVariant';
import {getDepositFormBinding} from '../../utils/getDepositFormBinding';
import {getServiceOrderVariantsRoutes} from '../../utils/getServiceOrderVariantsRoutes';

const INVOICE_SERIES_TYPE = 'accounting/invoice';

interface DepositTabProps {
  control: FormControl<FormType>;
  formApi: UseFormReturn<FormType>;
  invoiceTemplateOptions: DocumentTemplateOptionGroup[];
  isTemplatesLoading?: boolean;
}

export function DepositTab(props: DepositTabProps) {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const serviceOrderVariantsRoutes = getServiceOrderVariantsRoutes(pathname);

  const deposit = useWatch({control: props.control, name: 'deposit'});

  const {groupedSeries, isSeriesLoading} = useSeriesOptions([INVOICE_SERIES_TYPE]);

  return (
    <>
      <DepositSection
        control={props.control}
        binding={getDepositFormBinding(props.formApi)}
        deposit={deposit}
        docSeriesOptions={groupedSeries[INVOICE_SERIES_TYPE] ?? []}
        isDocSeriesLoading={isSeriesLoading}
        invoiceTemplateOptions={props.invoiceTemplateOptions}
        isTemplatesLoading={props.isTemplatesLoading}
        data-testid={testIds.settings.serviceOrderVariantsDetail('deposit')}
      />
      <SettingsFooter
        actions={[
          {
            type: 'button',
            variant: 'secondary',
            title: i18n.t('general.actions.discardChanges'),
            onClick: () => navigate(serviceOrderVariantsRoutes.overview),
          },
          {
            type: 'form-button',
            control: props.control,
            buttonType: 'submit',
            variant: 'primary',
            title: i18n.t('general.actions.saveChanges'),
          },
        ]}
        data-testid={testIds.settings.serviceOrderVariantsDetail('depositFooter')}
      />
    </>
  );
}
